import { Checkbox, MessageModalLayout, Text, WixDesignSystemProvider } from '@wix/design-system';
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';

import { AI_MODAL_DISCARD_MODAL } from '../data-hooks';

export type DiscardPayload = { confirmed: false } | { confirmed: true; dontShowAgain: boolean };

type DiscardConfirmationModalProps = {
  closeModal: (payload: DiscardPayload) => void;
};

export const DiscardConfirmationModal: React.FC<DiscardConfirmationModalProps> = ({
  closeModal,
}) => {
  const { t } = useContext(RicosContext);
  const [dontShowAgain, setDontShowAgain] = React.useState(false);
  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <MessageModalLayout
        dataHook={AI_MODAL_DISCARD_MODAL}
        onCloseButtonClick={() => closeModal({ confirmed: false })}
        primaryButtonOnClick={() => {
          closeModal({ confirmed: true, dontShowAgain });
        }}
        secondaryButtonOnClick={() => closeModal({ confirmed: false })}
        primaryButtonText={t('AIPlugin_DiscardModal_PrimaryButton_Text')}
        secondaryButtonText={t('AIPlugin_DiscardModal_SecondaryButton_Text')}
        title={t('AIPlugin_DiscardModal_Title')}
        content={<Text>{t('AIPlugin_DiscardModal_Content')}</Text>}
        sideActions={
          <Checkbox checked={dontShowAgain} onChange={() => setDontShowAgain(!dontShowAgain)}>
            {t('AIPlugin_DiscardModal_DontShowAgain')}
          </Checkbox>
        }
      />
    </WixDesignSystemProvider>
  );
};
